import React, { useState } from 'react'
import { Dropdown, DropdownItem, DropdownMenu } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { DropdownProps } from 'semantic-ui-react';
import { getUsersBrowserData, handleErrors } from '~/utils/helpers';
import { DownloadService } from '~/api/services/downloadFiles';

interface Props {
  verificationStatus: boolean
  selectedMonth: string
}

const StyledMenu = styled(Dropdown)<DropdownProps>`
  background: ${({ theme }) => theme?.firstColor} !important;
  color: white !important;

  .item {
    font-size: 15px !important;
    i {
      font-size: 15px !important;
    }
  }
`;

const Report:React.FC<Props> = ({ verificationStatus, selectedMonth }) => {
  const { t } = useTranslation()
  const userData = getUsersBrowserData()

  const [isLoading, setIsLoading] = useState(false)

  async function handleDownloadFile(url, data?, name?) {
    setIsLoading(true)
    try {
      await DownloadService.downloadFileWithName(url, { ...data }, name ?? '')
    } catch(error) {
      handleErrors(error)
    }
    setIsLoading(false)
  }

  return <StyledMenu
    text={t('Report')}
    icon='cloud download'
    floating
    direction={'left'}
    labeled
    button
    className='icon'
    loading={isLoading}
  >
    <DropdownMenu>
      {verificationStatus && <DropdownItem
        onClick={() => handleDownloadFile('milk-money/milk-payment/final/milk-deliveries/details/export', { month: selectedMonth })}
        icon='file excel outline' text={t('Milk money details')}
      />}
      <DropdownItem
        icon='file excel outline'
        text={t('Milk deliveries')}
        onClick={() => handleDownloadFile('milk-money/milk-payment/final/milk-deliveries/export', { ...userData, month: selectedMonth })}
      />
      {verificationStatus && <DropdownItem
        icon='file excel outline'
        text={t('Milchmengen LWA')}
        onClick={() => handleDownloadFile('milk-money/milk-payment/final/district-deliveries/preview/pdf', { month: selectedMonth })}
      />}
      {verificationStatus && <DropdownItem
        onClick={() => handleDownloadFile('milk-money/milk-payment/final/overall-statement/preview/pdf', { month: selectedMonth })}
        icon='file pdf outline'
        text={t('Overall milk money statement')}
      />}
    </DropdownMenu>
  </StyledMenu>
}
export default Report